// src/components/About2.js

import React from "react";
import { UserCircleIcon } from "@heroicons/react/solid";
import { aboutMe } from "../data";
import { education } from "../data";

export default function About2() {
  return (
    <section id="About2" className="container px-5 py-10 mx-auto text-center">

      <div className="flex flex-col w-full mb-20">
          <UserCircleIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            About Me
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            My name's Sam Pomerantz, and I'm a Senior at Boston University studying Computer Science
            and Finance. I'm passionate about developing tools that better the lives of others, especially 
            when it comes interactions with complex data and financial markets.
          </p>
          <p>
          Check out this <a className="text-indigo-400 leading-relaxed mb-5" href="https://unusualvolume.info/" target="_blank">Unusual Volume Detector</a>
          </p>
        </div>

    </section>
  );
}

